import { Injector, Injectable } from '@angular/core';
import { LoggerParamsTransformer } from '@content-platform/web-angular-shared-util-logging';
import { Store, select } from '@ngrx/store';
import { getADUser, getIsLoggedIn } from './auth/auth.selectors';
import * as i0 from "@angular/core";
export class AuthLoggingTransformer extends LoggerParamsTransformer {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.subscriptions = [];
    }
    initialize() {
        const store = this.injector.get(Store);
        this.subscriptions.push(store.pipe(select(getADUser)).subscribe((user) => (this.user = user)));
        this.subscriptions.push(store.pipe(select(getIsLoggedIn)).subscribe((loggedIn) => (this.loggedIn = loggedIn)));
    }
    getParams() {
        return {
            loggedIn: this.loggedIn,
            userName: this.user && this.user.userName,
            name: this.user && this.user.profile && this.user.profile.name
        };
    }
    ngOnDestroy() {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
    static { this.ɵfac = function AuthLoggingTransformer_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AuthLoggingTransformer)(i0.ɵɵinject(i0.Injector)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AuthLoggingTransformer, factory: AuthLoggingTransformer.ɵfac }); }
}
//# sourceMappingURL=auth-logging-transformer.js.map